import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './back_button.less'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/back_button')

class BackButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
  }

  render() {
    return (
      <div
        styleName="back-button"
        data-pa-click="back"
        onClick={this.props.onClick}
        role="link"
        tabIndex="0"
      >
        <span styleName="left-arrow" aria-hidden="true">
          {'\u21E0'}
        </span>
        <span styleName="back-text">{i18n('back')}</span>
      </div>
    )
  }
}

export default cssModules(BackButton, styles)
